<template>
    <NavContainerComponent v-if="isLoggedIn" />
    <SideBarComponent v-if="isLoggedIn" />
    <main class="main-content position-relative border-radius-lg ">
      <NavBarComponent v-if="isLoggedIn" />
      <router-view></router-view>
    </main>
</template>

<script>
import SideBarComponent from './components/SideBarComponent.vue';
import NavBarComponent from './components/NavBarComponent.vue';
import NavContainerComponent from './components/NavContainerComponent.vue';
import { accountService } from '@/_services';

export default {
  data() {
    return {
      isLoggedIn: false,
    };
  },
  watch: {
    '$route.name': 'checkLoginStatus',
  },
  updated() {
    this.checkLoginStatus();
  },
  created() {
    this.checkLoginStatus();
    console.log('Je me lance initialement ');
  },
  methods: {
    checkLoginStatus() {
      this.isLoggedIn = accountService.getToken();
      console.log('Valeur:', this.isLoggedIn);
    },
  },
  components: {
    NavContainerComponent,
    SideBarComponent,
    NavBarComponent,
  },
};
</script>

<style lang="scss">

</style>
